import { render, staticRenderFns } from "./Tdmguarapari.vue?vue&type=template&id=7a39f436&scoped=true"
import script from "./Tdmguarapari.vue?vue&type=script&lang=js"
export * from "./Tdmguarapari.vue?vue&type=script&lang=js"
import style0 from "./Tdmguarapari.vue?vue&type=style&index=0&id=7a39f436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39f436",
  null
  
)

export default component.exports